import React, { useState, useRef, useEffect } from "react";
import { Typography, Box, TextField, Button, Slide, Fade, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import Navbar from "../components/Navbar";

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#D9D9D9',
    borderRadius: '30px',
    border: 'none',
    transition: 'border 0.1s',
    '&:hover': {
      backgroundColor: '#D9D9D9',
    },
    '&.Mui-focused': {
      backgroundColor: '#D9D9D9',
      border: '3px solid black',
    },
    '& input': {
      fontWeight: 'bold',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

function Contact() {
  const containerRef = useRef(null);
  const [fadeIn, setFadeIn] = useState(false);
  const [delayedFadeIn, setDelayedFadeIn] = useState([false, false, false,false]);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    const { user_name, user_email, message } = formData;
    const email = 'rocs@cs-sport.fr';
    const subject = `Message from ${user_name}`;
    const body = `Name: ${user_name}\nEmail: ${user_email}\n\nMessage:\n${message}`;
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  useEffect(() => {
    const handleScroll = () => {
      const fadePosition = containerRef.current.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (fadePosition < screenHeight - 100) {
        setFadeIn(true);
        // Delay the appearance of each form field
        setTimeout(() => setDelayedFadeIn([true, false, false,false]), 10);
        setTimeout(() => setDelayedFadeIn([true, true, false,false]), 20);
        setTimeout(() => setDelayedFadeIn([true, true, true,false]),30);
        setTimeout(() => setDelayedFadeIn([true, true, true,true]),40);

      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box>
      <Navbar />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          overflowY: 'auto',
          backgroundColor: '#952f5a',
          color: '#ebe8e8',
          backgroundImage: `
            repeating-linear-gradient(to right,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0) calc(50% - 1px),
              #9f3161 calc(50% - 1px), #9f3161 calc(50% + 1px),
              rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
            )
          `,
          backgroundSize: 'calc(100% / 5) 100%',
          textAlign: 'center',
          padding: 2,
        }}
      >
        <Box ref={containerRef} sx={{ padding: '3rem' }}>
          <Slide direction="up" in={true} container={containerRef.current}>
            <Typography variant="h1" sx={{ fontSize: { xs: '4rem', lg: '8rem' }, fontWeight: 'bold' }}>CONTACT</Typography>
          </Slide>
        </Box>
      </Box>

      <Box
        id="content2"
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap:{xs:'0rem',md:'3rem'},
          paddingLeft: isSmallScreen ? 1 : 10,
          paddingRight: isSmallScreen ? 1 : 10,
          overflowY: 'auto',
          backgroundColor: 'rgba(58, 29, 29, 0.1)',
          backgroundImage: `
            repeating-linear-gradient(to right,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0) calc(50% - 1px),
              #FFFFFF calc(50% - 1px), #FFFFFF calc(50% + 1px),
              rgba(0, 0, 0, 0) calc(50% + 1px), rgba(0, 0, 0, 0) 100%
            )
          `,
          backgroundSize: 'calc(100% / 5) 100%'
        }}
      >
        <Fade in={fadeIn} timeout={1000}>
            <Box>
              <Typography sx={{ marginRight:'3rem',marginTop: '1rem', fontSize: {md:'4rem',sm:'3rem'}, fontWeight: 'bold',display: { xs: 'none', md: 'block' } }}>NOUS <br/> CONTACTER</Typography>
            </Box>
        </Fade>
        <form onSubmit={sendEmail} sx={{ display: 'flex',flexDirection: 'column',width: isSmallScreen ? '60%' : '500px' }}>
          <Fade in={delayedFadeIn[0]} timeout={500}>
            <Box sx={{display:'flex',gap:'2rem'}}>
              <Box>
                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>NOM</Typography>
                <CustomTextField
                  name="user_name"
                  variant="outlined"
                  margin="normal"
                  required
                  value={formData.user_name}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
              <Box>
                <Typography variant='body2' sx={{ fontWeight: 'bold'}}>ADRESSE MAIL</Typography>
                <CustomTextField
                  name="user_email"
                  type="email"
                  variant="outlined"
                  margin="normal"
                  required
                  value={formData.user_email}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            </Box>
          </Fade>
          <Fade in={delayedFadeIn[2]} timeout={500}>
            <Box>
              <Typography variant='body2' sx={{ fontWeight: 'bold', marginTop: '1rem' }}>MESSAGE</Typography>
              <CustomTextField
                name="message"
                variant="outlined"
                margin="normal"
                multiline
                sx={{width:"100%"}}
                rows={4}
                required
                value={formData.message}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Fade>
          <Fade in={delayedFadeIn[3]} timeout={500}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyItems: 'center' }}>
              <Button type="submit" variant="contained" sx={{
                              backgroundColor: '#96013C',
                              color: 'white',
                              padding: '10px 30px',
                              borderRadius: '20px',
                              fontWeight: 'bold',
                              marginTop:'1rem',
                              '&:hover': {
                                  backgroundColor: '#96013C',
                              },
                          }}
              >
                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>ENVOYER</Typography>
              </Button>
            </Box>
          </Fade>

        </form>
      </Box>
    </Box>
  );
}

export default Contact;
